import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Table, CardBox, EmptyState, Page } from '../../components';
import { retrieve } from '../../actions/organization-actions';
import { push } from '../../actions/nav-actions';
import { testRegex } from '../../utils';
import constants from '../../defaults/constants';
import { CSVLink } from 'react-csv';
import { getResourceReport,getUsersReport } from '../../api';
import { get } from '../../api/methods';
import Loader from '../../components/Loader';


const UserReport = ({ user, retrieve, organizations }) => {
  const [query, setQuery] = useState('');
const[users,setUsers]=useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    retrieve(user.token);

    getReport();
  
  }, []);

  const getReport = () => {
    const start = startDate && startDate !== undefined ? new Date(startDate).toLocaleDateString() : null
    const end = endDate && endDate !== undefined ? new Date(endDate).toLocaleDateString() : null
      setLoading(true);
  


    getUsersReport(user.token ,start,end).then((res) => {
        const formattedData = res.map((item) => ({
            ...item,
            dateSignedUp: new Date(item.created_at).toLocaleDateString(),
        }))
        setUsers(formattedData);
        console.log(formattedData);
        //  clean up
        setLoading(false);
     
     
        }
    ).catch((err) => {
        setLoading(false);
        console.log(err);
    }
    )



  };

  const renderEmpty = () => (
    <Loader/>
  );

  const renderChild = () => [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Username', accessor: 'username' },
    { Header: 'Email', accessor: 'email' },
    { 
        Header: 'Removed',
        accessor: 'removed',
        Cell: ({ value }) => (value ? 'Yes' : 'No') // Custom cell renderer for Yes/No
      },
    { 
        Header: 'Verified',
        accessor: 'verfied',
        Cell: ({ value }) => (value ? 'Yes' : 'No') // Custom cell renderer for Yes/No
      },
      {
        Header:"Admin",
        accessor:"is_admin",
        Cell:({value})=>(value ? 'Yes' : 'No')
      },
    { Header: 'Gender', accessor: 'gender' },
    { Header: 'Date Signed Up', accessor: 'dateSignedUp'}

  ];

  const handleDownload = () => {
    const data = users.map(
      ({
       
        _id,
        name,
        username,
        email,
        removed,
        verfied,
        gender,
        dateSignedUp,
        is_admin
        
        
        
        

      }) => ({
        
        _id,
        name,
        username,
        email,
        removed: removed ? 'Yes' : 'No',
        verfied: verfied ? 'Yes' : 'No', // Corrected variable name
        is_admin: is_admin ? 'Yes' : 'No',
        gender,
        dateSignedUp,
      })
    );
    return data;
  };

  const results = users.filter((i) => testRegex(i.name, query));

  const csvHeaders = [  
    
    { label: 'ID', key: '_id' },

    { label: 'Name', key: 'name' },

    { label: 'Username', key: 'username' },

    { label: 'Email', key: 'email' },

    { label: 'Removed', key: 'removed' },

    { label: 'Verfied', key: 'verfied' },

    {label :"Removed" ,key:"removed"},

    {label:"Gender" , key:"gender"}
  ];

  return (
    <Page title='User Report'>
      <div style={{ display: 'flex', }}>
        <div className='form-group'>
          <label>Start Date</label>
          <input
            type='date'
            className='form-control'
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className='form-group'>
          <label>End Date</label>
          <input
            type='date'
            className='form-control'
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        <div className='form-group'>

        {/* A filter button */}
        <button
          className='btn btn-info'
          style={{ marginLeft: 10, marginTop: 33 }}
          onClick={getReport}
        >
          { 'Filter'}
        </button>

      </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          // 
        }}
      >
        {/* Search box here */}
        <input
          type='text'
          className='form-control'
          placeholder='Search...'
          style={{ width: '25%', marginBottom: 33 }}
          onChange={(e) => setQuery(e.target.value)}
        />
        <CSVLink
          data={handleDownload()}
          headers={csvHeaders}
          filename={`user-report-${new Date().toLocaleDateString()}.csv`}
          className='btn btn-info btn-block'
          style={{ width: '20%', marginBottom: 33 }}
        >
          Download Users
        </CSVLink>
      </div>
      <CardBox>
        <Table id='survey' renderEmpty={renderEmpty} columns={renderChild()}  data={
          results
        }
        
         />
      </CardBox>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  organizations: state.organizations,
});

const mapDispatchToProps = (dispatch) => ({
  retrieve(token) {
    dispatch(retrieve(token));
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UserReport);


// WEBPACK FOOTER //
// ./src/routers/Reports/UserReport.js